/* eslint-disable no-param-reassign */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CandidateIdType } from 'src/context/types';
import { CandidateDetails } from 'src/pages/CandidateInfo/types';
import API from '../network';

export interface SelectedProfile {
  candidateInfo: CandidateDetails | undefined;
  status: string;
}

const initialState: SelectedProfile = {
  candidateInfo: undefined,
  status: '',
};

const defaultData = {
  candidateTitle: '',
  payType: '',
  payRate: '',
  consultancyId: '',
  consultancyContactId: '',
  consultancyPhoneNumber: '',
  extensionNumber: '',
  consultancyEmailAddress: '',
  firstName: '',
  middleName: '',
  lastName: '',
  reLocation: '',
  candidateLocation: '',
  experienceLevel: '',
  emailAddress: '',
  phoneNumber: '',
  dateOfBirth: '',
  visaStatus: '',
  resumeSource: '',
  comments: '',
  createdDate: '',
  updatedDate: '',
  socialLinks: '',
  resumeHtmlUrl: '',
  fileURL: '',
  presignedUrl: '',
  id: '',
  candidateId: '',
  candidateStatus: '',
};

export const fetchCandidateInfo = createAsyncThunk('profileSelector/fetchCandidateInfo', async (id: CandidateIdType) => {
  const response = await API.getInstance().fetchCandidateInfo(id);
  return response;
});

const profileSelector = createSlice({
  name: 'profileSelector',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCandidateInfo.pending, (state) => {
        state.status = 'loading';
        state.candidateInfo = defaultData;
      })
      .addCase(fetchCandidateInfo.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.candidateInfo = action.payload;
      })
      .addCase(fetchCandidateInfo.rejected, (state) => {
        state.status = 'failed';
        state.candidateInfo = defaultData;
      });
  },
});

export default profileSelector;
